import { gql } from '@apollo/client';

const GET_ALL_ACTIVE_USERS = gql`
  query GetAllActiveUsers {
    allActiveUsers {
      UserLicense {
        Email
        Name
        LicensedOrg
        LicensedOrgUnit
        SystemRole {
          Id
          DisplayName
        }
        SupplementalRoleId
        IsSuperUser
        CanAccessInvoices
      }

      AppraiserInfo {
        ExternalUserId
        DirectChannel
        Observation
      }
    }
  }
`;

export default GET_ALL_ACTIVE_USERS;
